import PropTypes from "prop-types"
import React, { useContext, useState, useEffect, useMemo, useRef, useCallback } from "react"
import { Link, useHistory } from "react-router-dom"
import { connect, useSelector } from "react-redux"
import debounce from "lodash.debounce"
import MenuCart from "./sub-components/MenuCart"
import { deleteFromCart, deleteAllFromCart, cartItemData, updateCartItem } from "../../redux/actions/cartActions"
import { _useToasts } from "../../common/_useToasts";
import axios from 'axios'
import { AuthContext } from "../../common/Auth"
import { USERTYPES } from "../../constant/userType"
import { X_TENANT_ID, SEARCHPRODUCT } from '../../common/ActionUrl'
import { getBrightnessFromColor, productPath } from '../../util/helper'
import AccountBalanceWalletOutlinedIcon from '@material-ui/icons/AccountBalanceWalletOutlined'
import useVisible from './useVisible';
import MonetizationOnOutlinedIcon from '@material-ui/icons/MonetizationOnOutlined';
import { DEFAULT_MENU_ITEMS } from "../../constant/headerMenuItems"
import { useThemeSettings } from "../../layouts/state/useThemeSettings"
import { usePaymentMethodSettings } from "../../layouts/state/usePaymentMethodSettings";
import { wishlistItemData } from "../../redux/actions/wishlistActions"
import { selectCartItems } from "../../redux/selectors/ cartSelectors"
import { getURLHelper } from "../../helpers/url"
import { useGetActiveBudgetsQuery, useGetEnabledQuery } from "../../redux/api/budgetApi"
import { useNavMenuFilter } from "./state/useNavMenuFilter";
import { useUserHooks } from "../../pages/other/state/useUserHooks"

const IconGroup = ( props ) => {
  const {currency, wishlistData, compareData, deleteFromCart, deleteAllFromCart, iconWhiteClass, artworkList, cartItemData, sidebarMenu, updateCartItem, execute, match: location, wishlistItemData} = props

  const { ref, isVisible, setIsVisible, isVisibleCart, setIsVisibleCart, isAccount, setIsAccount } = useVisible({ isVisible: false, isVisibleCart: false, isAccount: false });
  const { 
    themeSettingsData,
    userPoints,
    settingData,
    login,
    userBudget,
    ipV4,
    user,
    logout,
    userType,
    isAllowSelfRegistration,
    paymentMethodsSettings,
    storeStatus,
    categoriesByUserGroup,
    defaultUserGroup
  } = useContext(AuthContext)
  const [menuStyleData, setmenuStyleData] = useState({})
  const [userPointsData, setuserPoints] = useState(0)
  const [showVoucherBalance, setShowVoucherBalance] = useState(false);
  const [showGiftCardBalance, setShowGiftCardBalance] = useState(false);
  const { _addToast } = _useToasts()
  const history = useHistory()
  const [productNameList, setProductNameList] = useState([])
  const [tmp, setTemp] = useState(false)
  const [productCatList, setProductCatList] = useState([])
  const [productTagList, setproductTagList] = useState([])
  const [productColorList, setproductColorList] = useState([])
  const [productSizeList, setproductSizeList] = useState([])
  const [walletIcon, setWalletIcon] = useState(false);
  const [budgetIcon, setBudgetIcon] = useState(false);
  const [impersonateData, setImpersonateData] = useState({});
  const [dynamicMenuData, setDynamicMenuData] = useState(DEFAULT_MENU_ITEMS.menuItems);
  const [IsTestingMode, setIsTestingMode] = useState('');
  const userId = user?.userId
  const [tempValue, setTempValue] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [inputValue2, setInputValue2] = useState("");
  let reversalThreshold = 60;
  const iconColor = {
    color: menuStyleData.menuRightIconcolor
  }
  const [quantity, setQuantity] = useState(0);
  const [currentNode, setCurrentNode] = useState({});
  const [bubbleStyle, setBubbleStyle] = useState({});
  const [hoverColor, setHoverColor] = useState("");
  const [themeName, setThemeName] = useState('')
  const {
    itemNumber,
    themedefaultColor,
    showCompareToggle,
    showWishListToggle,
    isShowMyAccount,
    showAddToCartOnCat,
    showAddToCartOnProd,
    showOrderModuleInAccount,
    cartBubbleQuantity,
    cartBubbleLineItems,
    expandSearchBarUnderHeaderMenu,
    isShowSearchAccount,
  } = useThemeSettings({ settingData });
  const [budgetSettings, setBudgetSettings] = useState([])

  const {getSettingArrayByName} = usePaymentMethodSettings({ paymentMethodsSettings })
  const [openGiftCardInNewTab, setOpenGiftCardInNewTab] = useState(false);
  const [openVoucherInNewTab, setOpenVoucherInNewTab] = useState(false);
  const cartItems = useSelector(selectCartItems);
  const {
    filterMenuItems
  } = useNavMenuFilter({
    user,
    defaultUserGroup
  })
  const { data: newBudgetEnabled } = useGetEnabledQuery(undefined, { skip: !user })

  const { data: budgets } = useGetActiveBudgetsQuery(undefined, { skip: !user || !newBudgetEnabled || !budgetIcon })

  const { verifyPermission } = useUserHooks({ user })

    useEffect(() => {
        setBubbleStyle({
            color: menuStyleData.menuRightIconBubblecolor ? getBrightnessFromColor(menuStyleData.menuRightIconBubblecolor) < reversalThreshold ? '#fff' : '#000' : null,
            backgroundColor: menuStyleData.menuRightIconBubblecolor
        })
        setHoverColor(menuStyleData.menuRightIconHovercolor ? menuStyleData.menuRightIconHovercolor : themedefaultColor)
    }, [menuStyleData])
    useEffect(() => {
        if (themeSettingsData && themeSettingsData.length > 0) {
            themeSettingsData.map((i) => {
                if (i.settingsName === "headerMenu") {
                    if (i.values[0].menuSettings) {
                        setmenuStyleData(i.values[0].menuSettings)
                    }
                    if (i.values[0].menuItems) {
                      const menuItems = filterMenuItems(i.values[0].menuItems)
                      setDynamicMenuData(menuItems);
                      const openVoucher = i.values[0].menuItems.find( (item) => {
                        return item.staticName === 'voucherbalance';
                      });
                      const openGiftCard = i.values[0].menuItems.find( (item) => {
                        return item.staticName === 'giftcardbalance';
                      });
                      setOpenGiftCardInNewTab(!!openGiftCard?.opneNewTab);
                      setOpenVoucherInNewTab(!!openVoucher?.opneNewTab)
                    }
                }
                if (i.settingsName === "theme") {
                  setThemeName(i?.values?.[0]?.themeName)
                }
            })
        }
    }, [themeSettingsData])
  useEffect(() => {
    paymentMethodsSettings !== undefined && paymentMethodsSettings.map((val => {
      if (val.settingsName === 'pointsSettings') {

        setWalletIcon(val?.values[0]?.isIconEnabled)
      }
      if (val.settingsName === 'budgetSettings') {
        setBudgetIcon(val?.values[0]?.isIconEnabled)
      }
      if (val.settingsName === 'budgetSettings') {
        setBudgetSettings(val?.values[0])
      }
    }))
  }, [paymentMethodsSettings])


    const getProducts = (searchValue = "") => {
        const requestOptions = {
            headers: { 'X-TENANT-ID': X_TENANT_ID },
        }
        if (searchValue !== "" && searchValue !== "undefined" && searchValue !== undefined) {
          let url = SEARCHPRODUCT + `?productName=${searchValue}&user=${userId ?? ''}`
            axios.get(url, requestOptions)
                .then(async res => {
                    if (res.data.error) {
                      _addToast(res.data.message, {
                            appearance: "error",
                            autoDismiss: true
                        })
                    } else {
                        setProductNameList(res.data.products)
                        setProductCatList(res.data.categories)
                        setproductTagList(res.data.tags)
                        setproductColorList(res.data.colors)
                        setproductSizeList(res.data.sizes)
                    }
                })
                .catch(err => {
                    console.log('err', err)
                })
        } else {
            setProductNameList([])
            setProductCatList([])
            setproductTagList([])
            setproductColorList([])
            setproductSizeList([])
        }
    }

    useEffect(() => {
        if (userPoints && userPoints.points && paymentMethodsSettings) {
            const pointSettings = getSettingArrayByName("pointsSettings") || {}
            setuserPoints(pointSettings.showDecimals ? userPoints.points : Math.trunc(userPoints.points))
        }
    }, [userPoints, paymentMethodsSettings])

  useEffect(() => {
    if (paymentMethodsSettings && paymentMethodsSettings.length > 0) {
      const voucherConfig = getSettingArrayByName("voucherSettings") || {};
      const showVoucher = voucherConfig?.showInAccountBubble ?? false;
      setShowVoucherBalance(showVoucher);

      const giftCardConfig = getSettingArrayByName("giftcardSettings") || {};
      const showGiftCard = giftCardConfig?.showInAccountBubble ?? false;
      setShowGiftCardBalance(showGiftCard);
    }
  }, [paymentMethodsSettings])

    useEffect(()=>{
        if ( inputValue ) {
            getProducts(inputValue)
        }
    }, [inputValue])

    const debouncedChangeHandler = useMemo(
        () => debounce((newValue) => setInputValue(newValue), 300),
        []
    );

    const handleInputChange = (event) => {
        const newValue = event.target.value;
        setInputValue2(newValue);
        debouncedChangeHandler(newValue);
    }

  useEffect(() => {
    let rows = 0;
    if (cartItems.length > 0) {
      if (cartBubbleQuantity || !cartBubbleLineItems){
        for (let i = 0; i < cartItems?.length; i++) {
          for (let j = 0; j < cartItems?.[i]?.currentOrder.length; j++) {
            for (let k = 0; k < cartItems?.[i]?.currentOrder?.[j].length; k++) {
              rows += Number(cartItems[i].currentOrder[j][k].quantity);
            }
          }
        }
      } else {
        cartItems.forEach(order => {
          rows += order?.currentOrder?.length || 0;
        })
      }
      setQuantity(rows);
    } else {
      setQuantity(0);
    }
  }, [cartItems])

  useEffect(() => {
    getProducts();
    return () => {
        debouncedChangeHandler.cancel()
    }
  }, []);

    const handleClick = e => {
        // e.currentTarget.nextSibling.classList.toggle("active")
        setIsVisible(false)
        setIsVisibleCart(false)
        setIsAccount(!isAccount)
    }
    const handleMenuClick = (e) => {
        setIsVisibleCart(!isVisibleCart)
        setIsAccount(false)
        setIsVisible(false)
        let getCurrentElem = e.target.getBoundingClientRect();
        setCurrentNode(getCurrentElem)
    }
    const handleClickSearch = e => {
        document.getElementById("combo-box-demo").value = ""
        setIsVisible(!isVisible)
        setIsAccount(false)
        setIsVisibleCart(false)
        setProductNameList([])
        setProductCatList([])
        setproductTagList([])
        setproductColorList([])
        setproductSizeList([])
        setTempValue(!tempValue)
    }

    const clickonCartItem = () => {
        setIsVisibleCart(!isVisibleCart)
    }

    useEffect(() => {
        const timer = setTimeout(() => {
          if(!!document?.getElementById("combo-box-demo")) {
            document.getElementById("combo-box-demo").focus()
          }
        }, 500)
        return () => clearTimeout(timer)
    }, [tempValue])

    const triggerMobileMenu = () => {
        const offcanvasMobileMenu = document.querySelector(
            "#offcanvas-mobile-menu"
        )
        offcanvasMobileMenu.classList.add("active")
    }

    const goToProduct = (e, product) => {
        localStorage.removeItem('catTree')
        document.getElementById("searchBtnHeader").click()
        history.push(process.env.PUBLIC_URL + "/product/" + productPath(product))
    }
    const goToTagProduct = (e, tag) => {
        const params = new URLSearchParams()
        document.getElementById("searchBtnHeader").click()
        params.append("tags", tag._id)
        history.push({  pathname: '/products', search: params.toString() })
    }
    const goToCatProduct = (e, category)=>{
        const params = new URLSearchParams()
        document.getElementById("searchBtnHeader").click()
        params.append("cat", category._id)
        history.push({  pathname: '/products', search: params.toString() })
    }
    const goToColorProduct = (e, color)=>{
      const params = new URLSearchParams()
      document.getElementById("searchBtnHeader").click()
      params.append("colors", color)
      history.push({  pathname: '/products', search: params.toString() })
    }
    const goToSizeProduct = (e, size)=>{
      const params = new URLSearchParams()
      document.getElementById("searchBtnHeader").click()
      params.append("sizes", size.size)
      history.push({  pathname: '/products', search: params.toString() })
    }

    let impersonateUser = null
    useEffect(() => {
        impersonateUser = sessionStorage.getItem("impersonateUser") ? JSON.parse(sessionStorage.getItem("impersonateUser")) : ""
        setImpersonateData(impersonateUser)
    }, [user])

    useEffect(() => {
      setIsTestingMode(storeStatus)
    }, [storeStatus])

    const testMode = {
      color: 'white',
      backgroundColor: 'rgb(218, 9, 9)',
      margin: '10px 10px 10px 10px',
      position: 'fixed',
      /*top: '10px',
      left: '50%',*/
      zIndex: '99999',
      /*transform: 'translateX(-50%)',*/
      fontSize: '15px',
      fontFamily: 'Poppins, sans-serif',
      boxShadow: '0 2px 12px rgba(0,0,0,0.25)',
      padding: '6px 16px',
      borderRadius: '30px',
      fontWeight: '600',
      whiteSpace: 'nowrap',
      textTransform: 'capitalize',
      height: "35px",
      right : '62px',
      bottom: '54px'
    }
    /*useEffect(() => {
      if(IsTestingMode === "")
      {
        fetchStoreDetails().then(res => {
            let hostUrl = window.location.hostname
            if (process.env.NODE_ENV) {
              if (process.env.NODE_ENV === 'development') {
                hostUrl = "dev-webstore.aether-stores.io"
              }
            }
            hostUrl = hostUrl.replace('www.', '');
            if (res.data) {
              let storeData = res.data.filter(storeArray => storeArray.storeurl === hostUrl || storeArray.custom_dn.replace('www.', '') === hostUrl)
              if (storeData && storeData[0] && !!storeData[0]?.status) {
                  setIsTestingMode(storeData[0].status)
              }
            }
        })
      }
    })*/

    const handleKeyDown = (event)=>{
        if ( event.key === 'Enter' ) {
            event.preventDefault()
            history.push(process.env.PUBLIC_URL + `/products/?q=${ inputValue2 }`)
        }
    }

    const getRight = (amount) => {
      let object = {
        right: undefined
      }
      if(amount) {
        if(amount.toString().length >= 3) {
          let arrayAmount = amount.toString().split('.');
          if(arrayAmount.length === 2 && Number(arrayAmount?.[1]) !== 0) {
            object.right = '-40px'
          } else {
            object.right = '-25px'
          }
        }
      }
      return object
    }

    const getAmount = (amount) => {
      let value = 0;
      if(amount) {
        let arrayAmount = amount.toString().split('.');
        if(arrayAmount.length === 2 && Number(arrayAmount?.[1]) !== 0) {
          value = amount.toFixed(2);
        } else {
          value = amount;
        }
      }
      return value;
    }
    const getBudgetAmount = () => {
      if (newBudgetEnabled) {
        return budgets?.reduce((acc, budget) => acc + budget.balance, 0) ?? 0
      }
      return userBudget?.amount && userBudget?.status === 'Enable' ? getAmount(userBudget?.amount) : 0
    }
    return (
      <>
      {(IsTestingMode === 'Testing') && <div className='header-area' style={testMode}>YOU ARE IN TESTING MODE</div>}
      {(impersonateData && impersonateData?.isImpersonateUser) && <div className='impersonatingUser'>Impersonating User: <b>{impersonateData && impersonateData.isImpersonateUser ? user.userName : ""}</b></div>}
        <div ref={ref} className={`${sidebarMenu ? "icon-sidebar-menu" : "top-menu" }`}>
          <style>
            {`.dhover:hover {
                                color: ${hoverColor} !important;
                            }`}
          </style>
          <div
            className={`mt-3 header-right-wrap ${iconWhiteClass ? iconWhiteClass : ''
              } icon-auto`}
          >
            {dynamicMenuData && dynamicMenuData.length > 0 && dynamicMenuData.filter(menu => {
              if (menu.staticName && menu.staticName === "addButton") {
                if (menu.isEnabled && !['beach', 'menu-overlay'].includes(themeName)) {
                  return true
                }
                return false;
              }
            }).map((menuArray, index) => {
              return <a 
                href={getURLHelper(menuArray.anchorLink)}
                className="btn-cat" 
                key={index}
                onMouseOver={(e) => {
                    e.target.style.backgroundColor = !!menuArray?.menuItemBgHoverColor ? menuArray?.menuItemBgHoverColor : "#2670bb"
                    e.target.style.color = !!menuArray?.menuItemFontHoverColor ? menuArray?.menuItemFontHoverColor : "#fff"
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = !!menuArray?.menuItemBgColor ? menuArray.menuItemBgColor : '#2670bb'
                  e.target.style.color = !!menuArray?.menuItemFontColor ? menuArray.menuItemFontColor : '#fff'
                }}
                target={menuArray?.opneNewTab ? '_blank' : ''}
                style={{ backgroundColor: !!menuArray?.menuItemBgColor ? menuArray.menuItemBgColor : '#2670bb', color: !!menuArray?.menuItemFontColor ? menuArray.menuItemFontColor : '#fff', fontFamily: menuArray?.fontName ? menuArray.fontName : 'Nunito', fontSize: !!menuArray?.fontSize ? menuArray.fontSize + 'px' : '16px' }}> 
                    {menuArray.name}
                </a>
            })}
            {((!expandSearchBarUnderHeaderMenu && isShowSearchAccount)) ? 
            <div className="same-style header-search d-none d-lg-block">
              <button
                className="dhover search-active"
                onClick={(e) => handleClickSearch(e)}
                id="searchBtnHeader"
              >
                <i
                  className="antera-header-icon dhover pe-7s-search"
                  style={iconColor}
                  title="Search"
                />
              </button>

              <div className={`search-content  ${isVisible ? 'active' : ''} `}>
                <div>
                  <form>
                    <>
                      <div className="d-flex row col-md-12 input-box align-items-center mb-5 m-0 p-0">
                        <input
                          id="combo-box-demo"
                          onChange={handleInputChange}
                          type="text"
                          placeholder="Search Product"
                          autoComplete="off"
                          onKeyDown={handleKeyDown}
                        />
                          {
                              inputValue ?
                                  <Link className="button-search"
                                        to={ process.env.PUBLIC_URL + `/products/?q=${ inputValue }` }>
                                      <i className="pe-7s-search" title="Search"/>
                                  </Link> :
                                  <button
                                      className="button-search"
                                      onClick={ (event)=>{
                                          event.preventDefault()
                                      } }
                                  >
                                      <i className="pe-7s-search" title="Search"/>
                                  </button>
                          }
                      </div>

                      <div className="productSearchList d-flex row col-md-12 input-box align-items-center p-0 m-0">
                        {productNameList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Products</h4>
                              <ul>
                                {productNameList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToProduct(event, data)
                                    }}
                                  >
                                    {data[itemNumber]} - {data.productName}
                                  </li>
                                ))}
                              </ul>
                              {productNameList && productNameList.length >= 5 && 
                              <div className="view-all"><Link to={process.env.PUBLIC_URL + `/products/?q=${inputValue}`}>View all products</Link></div>
                              }
                            </div>
                          </>
                        )}

                        {productCatList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Categories</h4>
                              <ul>
                                {productCatList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToCatProduct(event, data)
                                    }}
                                  >
                                    {data.categoryName}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                        {productTagList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Tags</h4>
                              <ul>
                                {productTagList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToTagProduct(event, data)
                                    }}
                                  >
                                    {data.tagName}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                        {productColorList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Colors</h4>
                              <ul>
                                {productColorList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToColorProduct(event, data)
                                    }}
                                  >
                                    {data}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                        {productSizeList.length > 0 && (
                          <>
                            <div className="w-100 m-0">
                              <h4 className="f-w-600 pl-1">Sizes</h4>
                              <ul>
                                {productSizeList.map((data, index) => (
                                  <li
                                    className="ml-3"
                                    key={data.id}
                                    onClick={(event) => {
                                      event.preventDefault()
                                      goToSizeProduct(event, data)
                                    }}
                                  >
                                    {data.size}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  </form>
                </div>
              </div>
            </div>
            : ''}
			{isShowMyAccount &&
				<div className="same-style account-setting  d-lg-block">
					<button
						className="dhover account-setting-active"
						onClick={(e) => handleClick(e)}
					>
						<i
							className="antera-header-icon dhover pe-7s-user-female"
							style={iconColor}
							title="Account"
						/>
					</button>
					<div className={`antera-header-account-dropdown-container account-dropdown  ${isAccount ? 'active' : ''}`}>
						<ul>
							<li>
								{userId ? (
									<span
										className="single-price"
										style={{ cursor: 'pointer' }}
										onClick={() => {
											logout()
											history.push('/')
										}}
									>
										{' '}
										<a>Logout</a>
									</span>
								) : (
									<Link to={process.env.PUBLIC_URL + '/login'}>Login</Link>
								)}
							</li>

							{!userId && isAllowSelfRegistration && (
								<li>
									<Link to={process.env.PUBLIC_URL + '/register'}>
										Register
									</Link>
								</li>
							)}

							{userType && userType !== USERTYPES.USER && (
								<li>
									<Link to={process.env.PUBLIC_URL + '/banner'}>
										Banner
									</Link>
								</li>
							)}

              {userId && (
                  <li>
                      <Link to={process.env.PUBLIC_URL + '/my-account'}>
                          My Account
                      </Link>
                  </li>
              )}

              {(userId && showGiftCardBalance) && (
                <li>
                  <a target={openGiftCardInNewTab ? '_blank':'_self'} href={process.env.PUBLIC_URL + '/giftcardbalance'}>
                    Gift card balance
                  </a>
                </li>
              )}

              {(userId && showVoucherBalance) &&(
                <li>
                  <a target={openVoucherInNewTab ? '_blank':'_self'} href={process.env.PUBLIC_URL + '/voucherbalance'}>
                    Voucher balance
                  </a>
                </li>
              )}

              {showOrderModuleInAccount && userId && (
                  <li>
                      {dynamicMenuData && dynamicMenuData.length > 0 && dynamicMenuData.filter(menu => {
                          if (menu.staticName && menu.staticName === "orders") {
                              if (menu.isEnabled) {
                                  return true
                              }
                          }
                      }).map((menuArray, index) => {
                          return <Link key={index}
                                       to={process.env.PUBLIC_URL + menuArray.anchorLink}> {menuArray.name} </Link>
                      })}
                  </li>
              )}
              {verifyPermission('6') && (
                <li>
                  <a href={process.env.PUBLIC_URL + '/product-management'}>
                    Manage Products
                  </a>
                </li>
              )}
          </ul>
        </div>
      </div>
			}
            {showCompareToggle && (
              <div className="same-style header-compare">
                <Link to={process.env.PUBLIC_URL + '/compare'}>
                  <i
                    className="antera-header-icon  dhover pe-7s-shuffle"
                    style={iconColor}
                    title="Compare"
                  />
                  <span className="count-style" style={bubbleStyle}>
                    {compareData && compareData.length ? compareData.length : 0}
                  </span>
                </Link>
              </div>
            )}
            {showWishListToggle && (
              <div className="same-style header-wishlist">
                <Link to={process.env.PUBLIC_URL + '/wishlist'}>
                  <i
                    className="antera-header-icon dhover pe-7s-like"
                    style={iconColor}
                    title="Favorite"
                  />
                  <span className="count-style" style={bubbleStyle}>
                    {wishlistData && wishlistData.length
                      ? wishlistData.length
                      : 0}
                  </span>
                </Link>
              </div>
            )}

            {
              (showAddToCartOnCat === true || showAddToCartOnProd === true) &&

              <div className="same-style cart-wrap d-show d-none d-lg-block">
                <button
                  data-testid = "cart-plw"
                  className="dhover icon-cart"
                  onClick={(e) => handleMenuClick(e)}
                >
                  <i
                    data-testid = "cart-icon-plw"
                    className="antera-header-icon dhover pe-7s-cart"
                    style={iconColor}
                    title="Cart"
                  />
                  <span className="count-style" style={bubbleStyle}>
                    { quantity }
                  </span>
                </button>
                {/* menu cart */}
                <div>
                  {isVisibleCart && (
                    <MenuCart
                      clickonCartItem={clickonCartItem}
                      cartData={cartItems}
                      currency={currency}
                      deleteFromCart={deleteFromCart}
                      deleteAllFromCart={deleteAllFromCart}
                      currentNode={currentNode}
                      updateCartItem={updateCartItem}
                      closeCart={() => setIsVisibleCart(false)}
                    />
                  )}
                </div>
              </div>
            }
            {(showAddToCartOnCat === true || showAddToCartOnProd === true) && 
                <div className="same-style cart-wrap m-show d-block d-lg-none">
                    <Link className="icon-cart" to={process.env.PUBLIC_URL + '/cart'}>
                        <i className="antera-header-icon dhover pe-7s-cart" style={iconColor} />
                        <span className="count-style" style={bubbleStyle}>
                            {quantity}
                        </span>
                    </Link>
                </div>
            }

            {(userId && walletIcon) && (
              <div className="same-style cart-wrap d-block">
                <Link className="icon-cart" title="Wallet" to={process.env.PUBLIC_URL + '/wallet'}>
                  <AccountBalanceWalletOutlinedIcon
                    className="antera-header-icon dhover"
                    style={iconColor}
                  />
                  <span className="count-style" style={bubbleStyle}>
                    {userPointsData ? Number(userPointsData).toFixed(2) : 0}
                  </span>
                </Link>
              </div>
            )}
            {(userId && budgetIcon) && (
              <div className="same-style cart-wrap d-block">
                <Link className="icon-cart" title={budgetSettings?.budgetNameChange || 'Budget'} to={process.env.PUBLIC_URL + (newBudgetEnabled ? '/budgets' : '/budget')}>
                  <MonetizationOnOutlinedIcon
                    className="antera-header-icon dhover"
                    style={iconColor}
                  />
                  <span className="count-style budget-header-icon" style={{...bubbleStyle, ...getRight(getBudgetAmount())}}>
                    ${getBudgetAmount()}
                  </span>
                </Link>
              </div>
            )}

            <div className="same-style mobile-off-canvas d-block d-lg-none">
              <button
                className="dhover mobile-aside-button"
                onClick={() => triggerMobileMenu()}
              >
                <i className="antera-header-icon pe-7s-menu" style={iconColor} />
              </button>
            </div>
          </div>
        </div>
      </>
    )
}

IconGroup.propTypes = {
    compareData: PropTypes.array,
    currency: PropTypes.object,
    iconWhiteClass: PropTypes.string,
    deleteFromCart: PropTypes.func,
    wishlistData: PropTypes.array
}

const mapStateToProps = state => {
    return {
        currency: state.currencyData,
        wishlistData: state.wishlistData,
        compareData: state.compareData
    }
}

const mapDispatchToProps = dispatch => {
    return {
        deleteFromCart: (item, _addToast,isPriceBreak, mainIndex, rowIndex) => {
            dispatch(deleteFromCart(item, _addToast,isPriceBreak, mainIndex, rowIndex))
        },
        deleteAllFromCart: (_addToast) => {
            dispatch(deleteAllFromCart(_addToast))
        },
		cartItemData:(Data)=>{
			dispatch(cartItemData(Data))
		},
    wishlistItemData:(Data)=>{
			dispatch(wishlistItemData(Data))
		},
        updateCartItem:(Data)=>{
			dispatch(updateCartItem(Data))
		}
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IconGroup)
